export default {
    bind(element, binding, node) {
        element.event = event => {
            if (!(element === event.target || element.contains(event.target))) {
                node.context[binding.expression](event)
            }
        }
        document.body.addEventListener('click', element.event)
    },
    unbind(element) {
        document.body.removeEventListener('click', element.event)
    }
}
